export default __webpack_public_path__ + "static/medtronic-3b9d6e42132a597c3c89468af3a11009.svg";